import { useSelector } from 'react-redux';

import { getQuestionById } from '../../../selectors/questions';
import { Comment } from '../../../components/Comment';
import { CommentPart } from '../../../components/CommentPart';

interface IQuestionContainerProps {
  questionId: string;
}

export function QuestionContainer({ questionId }: IQuestionContainerProps) {
  const { comment } = useSelector(getQuestionById(questionId));

  return (
    <Comment>
      <CommentPart message={comment.legacy} />
    </Comment>
  );
}
